/**
 * llpause paleti — soğuk aile (lacivert, indigo, petrol, eflatun). Kahverengi/bej/kiremit yok.
 *
 * Matcap dokuları tools/blender/matcaps.py ile üretilir; renkler aynı dosyadaki MATCAPS listesinden gelir.
 * GLB içindeki nesne adı `shade<Ad>` ise bu listedeki <ad> matcap'ini alır (ör. shadeIndigo → indigo).
 *
 * `legacy`: folio-2019'dan kalan modellerde geçen eski adları yeni renklere yönlendirir.
 * Kendi modellerinde yalnızca `matcaps` içindeki adları kullan.
 */
// Renk dünyaları (T tuşu / TEMA alanı). Kapı: beyaz zemin yazısının köşe renklerine karşı en düşük
// kontrastı 1.15'in altına düşmez — lavanta 1.22, gece 12.78, buz 1.17, mandalina 1.31, pamuk şeker 1.31, nane 1.21. Kahverengi/bej yok.
export const themes = {
    lavanta: {
        name: { tr: 'LAVANTA', en: 'LAVENDER' },
        floor: { topLeft: '#9dacf7', topRight: '#b8a4f5', bottomRight: '#e9e6fd', bottomLeft: '#c6d4f8' },
        indirectColor: '#4a3fd1',
        shadowColor: '#2a2878',
        glow: '#e7e4ff',
        background: '#cfd8f7'
    },
    gece: {
        name: { tr: 'GECE', en: 'NIGHT' },
        floor: { topLeft: '#262d63', topRight: '#33276b', bottomRight: '#11152e', bottomLeft: '#191e46' },
        indirectColor: '#7b6dff',
        shadowColor: '#04050d',
        glow: '#3a3f9e',
        background: '#141833'
    },
    buz: {
        name: { tr: 'BUZ', en: 'ICE' },
        floor: { topLeft: '#74c9dc', topRight: '#93b3f3', bottomRight: '#d3f3f7', bottomLeft: '#a9e3dc' },
        indirectColor: '#138a86',
        shadowColor: '#0f4f5c',
        glow: '#e6fffb',
        background: '#b9e4df'
    },
    // Kullanıcı: enerjik turuncu–sarı. Gölge ahududu: turuncuyla karışınca mercan olur
    // (lacivert gölge turuncuyu kahveye çekerdi)
    mandalina: {
        name: { tr: 'MANDALİNA', en: 'TANGERINE' },
        floor: { topLeft: '#ffc629', topRight: '#ff8636', bottomRight: '#ffdf6b', bottomLeft: '#ffa53d' },
        indirectColor: '#ff5a1f',
        shadowColor: '#d42f6a',
        glow: '#fff1c2',
        background: '#ffc46b'
    },
    seker: {
        name: { tr: 'PAMUK ŞEKER', en: 'COTTON CANDY' },
        floor: { topLeft: '#ffa8d2', topRight: '#c79cff', bottomRight: '#ffd6ea', bottomLeft: '#ffbfe0' },
        indirectColor: '#e02a86',
        shadowColor: '#7c2a8c',
        glow: '#fff0f8',
        background: '#ffc9e3'
    },
    nane: {
        name: { tr: 'NANE', en: 'MINT' },
        floor: { topLeft: '#5fe0b0', topRight: '#7fd3f2', bottomRight: '#c2f5df', bottomLeft: '#96ecc9' },
        indirectColor: '#0d9e78',
        shadowColor: '#0b5d63',
        glow: '#eafff6',
        background: '#a8efd3'
    }
}
export const themeOrder = ['lavanta', 'gece', 'buz', 'mandalina', 'seker', 'nane']

export default {
    floor: {
        topLeft: '#9dacf7',
        topRight: '#b8a4f5',
        bottomRight: '#e9e6fd',
        bottomLeft: '#c6d4f8'
    },

    // Işık rengi — tek parametre: bütün nesnelerin aydınlatmasını bu renkle çarpar (beyaz nesne tam bu renge döner).
    // '#ffffff' nötr beyaz; kullanıcı isteğiyle hafif sarı-sıcak (2026-09-25). Bej/kahveye kaymasın: çok açık tut.
    lightTint: '#fff5e3',

    // Zeminden nesnelere yansıyan dolaylı ışık rengi
    indirectColor: '#4a3fd1',

    // Zemine basılan (bake edilmiş) gölgelerin rengi
    shadowColor: '#2a2878',

    // Ekranın üst kısmındaki yumuşak parlama (post-process)
    glow: '#e7e4ff',

    // Proje panolarının çerçeve rengi
    boardColor: '#2b2f73',

    matcaps: [
        'white',
        'black',
        'gray',
        'lavender',
        'indigo',
        'navy',
        'accent',
        'petrol',
        'teal',
        'violet',
        'blue',
        'raspberry',
        'ice',
        'metal',
        'taiga',
        'mint',
        'pistachio',
        'blush',
        'lilac',
        'scarlet',
        'lemon'
    ],

    legacy: {
        beige: 'lavender',
        brown: 'indigo',
        orange: 'accent',
        green: 'petrol',
        emeraldGreen: 'teal',
        purple: 'violet',
        red: 'raspberry',
        yellow: 'ice',
        gold: 'ice'
    },

    // Işık/parlak yüzeyler (pure<Ad>) — gölgelemesiz düz renk
    pures: {
        white: '#ffffff',
        red: '#d0102c', // fren lambaları: derin kırmızı (pembe #ff4f86 kırmızı gövdede kayboluyordu)
        yellow: '#dff1ff',
        cyan: '#5ef2ff'
    }
}
